import { FormLabel, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomFormLabel = styled(FormLabel)(({ theme }) => {
    return {
        fontSize: `${theme.typography.p2.fontSize.large}rem`,
        lineHeight: `${theme.typography.getLineHeight('p2', 'large')}rem`,
        color: theme.palette.ensightful.neutral[900],
    };
});

export default forwardRef((props, ref) => {
    return <CustomFormLabel ref={ref} {...props} />;
});
